// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1EntrySchema = z.object({
  id: z.number().int().describe("Unique identifier for the entry"),
  type: z.coerce.string().describe("Application/source type (e.g., Gmail, GitHub, Calendar)"),
  uid: z.coerce.string().describe("Unique string identifier for the entry"),
  title: z.coerce.string().describe("Entry title").nullish(),
  note: z.coerce.string().describe("Entry notes or description").nullish(),
  description: z.coerce.string().describe("Detailed description of the entry").nullish(),
  date: z.coerce.string().describe("Date of the entry in YYYY-MM-DD format"),
  from: z.coerce.string().describe("Start time in ISO 8601 format").nullish(),
  to: z.coerce.string().describe("End time in ISO 8601 format").nullish(),
  entry_type: z.coerce.string().describe("Type of entry (e.g., meeting, task, email)").nullish(),
  sensitivity: z.enum(["normal", "personal", "private", "confidential"]).describe("Outlook event sensitivity: normal, personal, private, confidential (null for legacy non-Outlook entries)").nullish(),
  duration: z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  }).describe("Duration of the entry"),
  at: z.coerce.string().describe("Specific time point in ISO 8601 format").nullish(),
  extra_attributes: z.array(z.object({})).describe("Additional attributes specific to entry type"),
  icon: z.coerce.string().describe("Icon identifier for the entry").nullish(),
  color: z.coerce.string().describe("Color code for the entry").nullish(),
  sub_entries: z.array(z.object({
    id: z.number().int(),
    uid: z.coerce.string(),
    entry_id: z.number().int(),
    from: z.coerce.string().nullish(),
    to: z.coerce.string().nullish(),
    note: z.coerce.string().nullish(),
  })).describe("Sub-entries or time segments"),
  icon_url: z.coerce.string().describe("URL for the entry icon").nullish(),
  icon_fallback_url: z.coerce.string().describe("Fallback URL for the entry icon").nullish(),
  url: z.coerce.string().describe("Related URL for the entry").nullish(),
});
